// LiveStreamGiftDiamond.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { textColor } from '../style/variables.js';
import numberWithCommas from '../resource/numberWithCommas.js';
import DiamondIconSrc from '../../img/point_2.svg';
import Flip from './Flip.jsx';
import LoadingIconSrc from '../../img/img-loading-dark-20.svg';
import ArrowRightIconSrc from '../../img/ic-arrow-right-tealblue-12.svg';

export class LiveStreamGiftDiamond extends React.PureComponent {
  render() {
    const { giftDiamondCount } = this.props;
    return (
      <StyledLiveStreamGiftDiamond>
        <GiftDiamond>
          <DiamondIcon src={DiamondIconSrc} alt="diamond icon" />
          {giftDiamondCount === null && (
            <DiamondLoader>
              <LoadingIcon src={LoadingIconSrc} />
            </DiamondLoader>
          )}
          {giftDiamondCount !== null && (
            <GiftDiamondWrapper>
              <Flip>{numberWithCommas({ number: giftDiamondCount })}</Flip>
              <ArrowRightIcon src={ArrowRightIconSrc} aria-hidden />
            </GiftDiamondWrapper>
          )}
        </GiftDiamond>
      </StyledLiveStreamGiftDiamond>
    );
  }
}

LiveStreamGiftDiamond.propTypes = {
  giftDiamondCount: PropTypes.number,
};

LiveStreamGiftDiamond.defaultProps = {
  giftDiamondCount: 0,
};

const StyledLiveStreamGiftDiamond = styled.div`
  width: auto;
  padding: 0 12px;
  height: 24px;
  border-radius: 12px;
  display: inline-flex;
  justify-content: center;
  flex-direction: column;
  align-items: start;
  color: ${textColor.primary};
  font-size: 12px;
  font-weight: 500;
  background-color: rgba(35, 35, 35, 0.4);
  cursor: pointer;
`;

const DiamondLoader = styled.div`
  position: relative;
  img {
    width: 16px;
    height: 16px;
  }
`;

const GiftDiamondWrapper = styled.div`
  display: flex;
  align-items: center;
  line-height: 1;
`;

const DiamondIcon = styled.img`
  margin-right: 2px;
  width: auto;
  height: 16px;
`;

const ArrowRightIcon = styled.img`
  width: auto;
  height: 8px;
  margin-left: 4px;
`;

const LoadingIcon = styled.img``;

const GiftDiamond = styled.div`
  display: flex;
  height: 16px;
`;

export default LiveStreamGiftDiamond;
